import Vue from 'vue'
import koreanDictionary from 'vee-validate/dist/locale/ko'
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import { email, max, min, numeric, required } from 'vee-validate/dist/rules'

const lang = Vue.prototype.$lang === 'KR' ? 'ko' : 'en'

const koDictionary = Object.assign(koreanDictionary, {
  messages: {
    ...koreanDictionary.messages,
    email: '입력형식이 올바르지 않습니다.',
  }
})
localize(lang, koDictionary)

extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('required', required)

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
